/**
 * Granny flat — reasonable value conversion factors.
 * Source: DSS Social Security Guide 4.6.4.60.
 * Ported verbatim from frontend/src/constants/grannyFlatConversionFactors.js.
 */
export const GRANNY_FLAT_CONVERSION_FACTORS: Record<number, number> = {
    51: 33.94, 52: 33.02, 53: 32.09, 54: 31.18, 55: 30.27,
    56: 29.37, 57: 28.47, 58: 27.57, 59: 26.69, 60: 25.80,
    61: 24.92, 62: 24.05, 63: 23.18, 64: 22.33, 65: 21.48,
    66: 20.64, 67: 19.80, 68: 18.98, 69: 18.16, 70: 17.36,
    71: 16.56, 72: 15.77, 73: 15.01, 74: 14.25, 75: 13.50,
    76: 12.78, 77: 12.07, 78: 11.37, 79: 10.70, 80: 10.04,
    81: 9.41, 82: 8.80, 83: 8.21, 84: 7.65, 85: 7.11,
    86: 6.60, 87: 6.13, 88: 5.68, 89: 5.26, 90: 4.87,
    91: 4.52, 92: 4.19, 93: 3.89, 94: 3.63, 95: 3.40,
    96: 3.19, 97: 3.01, 98: 2.86, 99: 2.72, 100: 2.60,
};

/** Youngest age in the table; below this, use age 51's factor (the table starts at 51). */
export const GRANNY_FLAT_MIN_AGE = 51;
/** Above this age, keep using the age-100 factor. */
export const GRANNY_FLAT_MAX_AGE = 100;

/**
 * Look up the granny-flat conversion factor for an "age next birthday".
 * Clamps to [51, 100] per the Guide (over 100 uses the 100 factor).
 */
export function getGrannyFlatConversionFactor(ageNextBirthday: number): number {
    const age = Math.round(Number(ageNextBirthday));
    if (!Number.isFinite(age)) return GRANNY_FLAT_CONVERSION_FACTORS[GRANNY_FLAT_MAX_AGE]!;
    const clamped = Math.min(GRANNY_FLAT_MAX_AGE, Math.max(GRANNY_FLAT_MIN_AGE, age));
    return GRANNY_FLAT_CONVERSION_FACTORS[clamped]!;
}

export default GRANNY_FLAT_CONVERSION_FACTORS;
